import { CompanyCandidate, CompetencyMap, Examination, Trial, Trial_Status } from "@generated/graphql";
import dayjs from "dayjs";

interface GetTrialFileNameParams {
  trial?: Pick<Trial, "completedAt" | "numericId">;
  examination?: Pick<Examination, "title" | "numericId">;
  competencyMap?: Pick<CompetencyMap, "title"> | null;
  companyCandidate?: Pick<CompanyCandidate, "fullName">;
}

export const getTrialFileName = ({ trial, examination, competencyMap, companyCandidate }: GetTrialFileNameParams) => {
  const fileName = [
    examination?.title,
    companyCandidate?.fullName,
    competencyMap?.title,
    trial?.numericId,
    trial?.completedAt ? dayjs(trial.completedAt).format("DD.MM.YYYY") : null,
  ].filter(Boolean) as (string | number)[];

  return `${fileName.join("_")}.pdf`;
};

interface GetExaminationFileNameParams {
  examination: Pick<Examination, "title" | "numericId">;
}

export const getExaminationFileName = ({ examination }: GetExaminationFileNameParams) => {
  return `Отчеты_${examination.title} id_${examination.numericId}.zip`;
};

export const getIsTrialEnableForReminder = (trial: Pick<Trial, "status">) => {
  return [Trial_Status.Created, Trial_Status.Received, Trial_Status.Suspended, Trial_Status.Started].includes(
    trial.status
  );
};
